const state = {
  loading: false,
  snackbar: {
    visible: false,
    color: null,
    text: null,
    timeout: 6000,
    multiline: false,
  },
  // search_error: null,
};

const mutations = {
  showSnackbar(state, payload) {
    state.snackbar.text = payload.text;
    state.snackbar.multiline = payload.text.length > 50;

    if (payload.color) {
      state.snackbar.color = payload.color;
    }

    if (payload.multiline) {
      state.snackbar.multiline = payload.multiline;
    }

    if (payload.timeout) {
      state.snackbar.timeout = payload.timeout;
    }

    state.snackbar.visible = true;
  },
  closeSnackbar(state) {
    state.snackbar.visible = false;
    state.snackbar.color = null;
    state.snackbar.text = null;
    state.snackbar.multiline = false;
    state.snackbar.timeout = 6000;
  },
  showLoader(state, payload) {
    state.loading = payload;
  },
  closeLoader(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  showLoader: ({ commit }) => commit('showLoader'),
  closeLoader: ({ commit }) => commit('closeLoader'),
};

const getters = {
  isLoading: (state) => state.loading,
  snackbar: (state) => state.snackbar,
  // searchError: (state) => state.search_error,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
